import { createFileRoute, redirect } from '@tanstack/react-router';
import { authClient } from '@/lib/auth-client';
import CompleteProfile from '@/pages/CompleteProfile';

export const Route = createFileRoute('/complete-profile')({
  beforeLoad: async () => {
    const session = await authClient.getSession({
      fetchOptions: { credentials: 'include' },
    });

    // Not authenticated — redirect to login
    if (!session.data) {
      throw redirect({ to: '/login' });
    }

    // Already has an org — redirect to dashboard
    const user = session.data.user as Record<string, unknown>;
    if (user.organizationId) {
      throw redirect({ to: '/' });
    }
  },
  pendingComponent: () => (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-muted-foreground">Loading...</div>
    </div>
  ),
  component: CompleteProfile,
});
